module.exports = __webpack_public_path__ + "static/media/vip-room.f46f927b.png";